import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { MessagesView } from "../../../views/app/messages/messages.view";
import {
  GetPlattformMessagesParams,
  MessagePrimaryChannelStatus,
  MessagePrimaryChannelStatusParameter,
  MessageSortByParam,
  MessageSortParameter,
  MessageType,
  MessageTypeParameter,
  MessageValidationStatusParameter,
  ValidationStatus,
} from "@bvhi/backend-api/apis";

export const Route = createFileRoute("/_main/app/messages/")({
  validateSearch: (search: Record<string, unknown>): GetPlattformMessagesParams => {
    return {
      page: Number(search?.page ?? 0),
      size: Number(search?.size ?? 25),
      sort: (search?.sort as MessageSortParameter) || [MessageSortByParam.CREATED_AT_DESC],
      messageType: (search?.messageType as MessageTypeParameter) || [
        MessageType.DESPATCH_ADVICE,
        MessageType.INVOICE,
        MessageType.ORDER,
        MessageType.OTHER,
        MessageType.TEST,
        MessageType.TRANSPORT_ACKNOWLEDGEMENT,
      ],
      messagePrimaryChannelStatus: (search?.messagePrimaryChannelStatus as MessagePrimaryChannelStatusParameter) || [
        MessagePrimaryChannelStatus.ACTIVE,
        MessagePrimaryChannelStatus.DELIVERED,
        MessagePrimaryChannelStatus.FAILED,
        MessagePrimaryChannelStatus.STALLED,
      ],
      messageValidationStatus: (search?.messageValidationStatus as MessageValidationStatusParameter) || [
        ValidationStatus.INVALID,
        ValidationStatus.VALID,
        ValidationStatus.OPEN,
      ],
    };
  },
  component: () =>
    WithErrorBoundary({
      Component: withPermissionCheck({ Component: MessagesView }),
    }),
});
